import { PageController } from '@client/components/_core/layout/PageController';
import { ComplianceAuditTemplateEvidenceTypeEdit } from '@client/components/compliance-audit-templates/ComplianceAuditTemplateEvidenceTypeEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: { title: 'Edit evidence type' },
    },
    params: {
        parse: ({ complianceAuditTemplateEvidenceTypeId }) => ({
            complianceAuditTemplateEvidenceTypeId: BigInt(complianceAuditTemplateEvidenceTypeId),
        }),
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { complianceAuditTemplateId, complianceAuditTemplateEvidenceTypeId } = Route.useParams();

    return (
        <PageController route={Route}>
            <ComplianceAuditTemplateEvidenceTypeEdit
                complianceAuditTemplateId={complianceAuditTemplateId}
                action={['edit', complianceAuditTemplateEvidenceTypeId]}
            />
        </PageController>
    );
}
